import { gql, useQuery } from "@apollo/client";
import { useStyletron } from "baseui";
import { Role } from "containers/Roles/roles";
import { useAuth } from "contexts/auth-context";
import React from "react";
import { Controller, UseControllerProps } from "react-hook-form";
import { Ban } from "tabler-icons-react";
import { PERMISSIONS } from "utils/permissions";

import Select, { SelectProps } from "./select";

export function ControlledRolesSelect({
  control,
  disabled,
  name,
  rules,
  ...rest
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
UseControllerProps<any> & SelectProps): React.ReactElement {
  const { checkPermission } = useAuth();
  const [css] = useStyletron();
  const { data, loading } = useQuery(
    gql`
      query {
        roles(paging: { limit: 10000 }) {
          nodes {
            id
            name
          }
        }
      }
    `
  );

  const hasPermission = checkPermission(PERMISSIONS.role.read);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value, name } }) => (
        <Select
          id={name}
          options={data?.roles?.nodes?.map(({ id, name }: Role) => ({
            id,
            label: name,
          }))}
          placeholder={
            hasPermission ? (
              "Wybierz"
            ) : (
              <div
                className={css({
                  display: "flex",
                  alignItems: "center",
                  gap: " 5px",
                })}
              >
                <Ban size={16} />
                Brak uprawnień do przeglądania ról
              </div>
            )
          }
          disabled={disabled || !hasPermission}
          isLoading={loading}
          onChange={(params) => params && onChange(params.value)}
          onBlur={onBlur}
          {...(data && { value: value })}
          {...rest}
        />
      )}
    />
  );
}

export function RolesSelect({
  ...rest
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
UseControllerProps<any> & SelectProps): React.ReactElement {
  const { data, loading } = useQuery(
    gql`
      query {
        roles(paging: { limit: 10000 }) {
          nodes {
            id
            name
          }
        }
      }
    `
  );

  return (
    <Select
      options={data?.roles?.nodes?.map((item: Role) => ({
        id: item?.id,
        label: item?.name,
      }))}
      isLoading={loading}
      placeholder="Wybierz"
      {...rest}
    />
  );
}
